<div class="multi-select-advanced" [ngClass]="{
  'multi-select-advanced--disabled': isDisabled
}">
  <div class="multi-select-advanced__head">
    <div class="multi-select-advanced__head-title">
      <app-badge color="secondary" [closable]="true" (closeClicked)="titleClick.emit()"
                 class="multi-select-advanced__head-title-text">
        {{ title }}
      </app-badge>
      <app-badge color="light">
        {{ 'multi_select_advanced_counter' | t }} {{ selectedItemsCount }}
      </app-badge>
    </div>
    <div class="multi-select-advanced__head-unspecified-option" *ngIf="unspecifiedOptionTitle">
      <app-checkbox [fc]="unspecifiedOptionControl"></app-checkbox>

      {{ unspecifiedOptionTitle }}
    </div>
  </div>
  <div class="multi-select-advanced__content">
    <ng-container *ngIf="options.length > 0; else emptyList">

      <label *ngFor="let item of options" class="multi-select-advanced__option">
        <app-checkbox-template [checked]="isSelected(item.id)" [disabled]="isDisabled"></app-checkbox-template>

        <input type="checkbox"
               [value]="item.id"
               (change)="updateSelected($event, item)"/>

        <app-badge [color]="isDisabled ? COLOR_STYLES.LIGHT : badgeColor">{{ item.itemName }}</app-badge>
      </label>
    </ng-container>
    <ng-template #emptyList>

      <div class="multi-select-advanced__option">
        {{ 'multi_select_advanced_empty_list' | t }}
      </div>
    </ng-template>
  </div>
  <div class="multi-select-advanced__foot" *ngIf="customOptionTitle">
    <app-button buttonStyle="unstyled"
                (click)="createCustomItem.emit()">

      <div class="multi-select-advanced__add-custom-option">
        <app-icon [name]="ICONS.PLUS_16"></app-icon>
        {{ customOptionTitle }}
      </div>
    </app-button>
  </div>
</div>
